<template>
  <div class="expired-subs">
    <h1 class="title">
      <!-- TODO добавить переводы -->
      <template v-if="subsStatus === 'incomplete'">
        Your payment is still processing
      </template>

      <template v-else-if="subsStatus === 'incomplete_expired'">
        Your payment wasn't successfull - update the payment method
      </template>

      <template v-else-if="subsStatus === 'past_due' || subsStatus === 'unpaid'">
        Your subscription expired
      </template>

    </h1>
    <app-btn :to="`/dashboard/plans`">{{$ml.get('Check our plans')}}</app-btn>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  methods: {

  },
  watch: {

    'subsStatus': function (to, from) {

      if(to === 'active') {
        this.$router.replace('/dashboard');
      }
    }
  },
  computed: {

    ...mapGetters({
      subsStatus: 'user/subsStatus',
    })
  }
}
</script>

<style lang="scss" scoped>

.expired-subs {

  display: flex;
  align-items: center !important;
  justify-content: center !important;

  .title {
    // font-size: 26px;
  }
}

</style>
